module.exports = __webpack_public_path__ + "img/chinaFlags.c4c2cf7f.png";